<template>
  <div class="form-page">
    <!-- Header com navegação -->
    <nav class="form-navbar">
      <div class="container">
        <div class="d-flex justify-content-between align-items-center">
          <div class="navbar-brand">
            <img src="../assets/images/logo.png" alt="Logo" height="40" />
          </div>
          <div class="navbar-actions">
            <button @click="voltarHome" class="btn btn-outline-primary">
              <i class="fas fa-arrow-left me-1"></i>Voltar
            </button>
          </div>
        </div>
      </div>
    </nav>

    <!-- Progress Indicator -->
    <div class="progress-section">
      <div class="container">
        <div class="progress-container">
          <div class="progress-step" :class="{ active: currentStep >= 1, completed: currentStep > 1 }">
            <div class="step-number">1</div>
            <div class="step-label">Dados Pessoais</div>
          </div>
          <div class="progress-line" :class="{ active: currentStep > 1 }"></div>
          <div class="progress-step" :class="{ active: currentStep >= 2, completed: currentStep > 2 }">
            <div class="step-number">2</div>
            <div class="step-label">Endereço</div>
          </div>
          <div class="progress-line" :class="{ active: currentStep > 2 }"></div>
          <div class="progress-step" :class="{ active: currentStep >= 3, completed: currentStep > 3 }">
            <div class="step-number">3</div>
            <div class="step-label">Contato</div>
          </div>
          <div class="progress-line" :class="{ active: currentStep > 3 }"></div>
          <div class="progress-step" :class="{ active: currentStep >= 4, completed: currentStep > 4 }">
            <div class="step-number">4</div>
            <div class="step-label">Acesso</div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-main">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 col-xl-7">
            <form @submit.prevent="salvar" class="modern-form">
              <!-- Header do Formulário -->
              <div class="form-header">
                <div class="form-logo">
                  <img src="../assets/images/logo.png" alt="Logo" />
                </div>
                <h2 class="form-title">Cadastro de Candidato</h2>
                <p class="form-subtitle">Preencha seus dados para participar dos concursos públicos</p>
              </div>

              <!-- Aviso LGPD -->
              <div class="lgpd-notice">
                <div class="notice-icon">
                  <i class="fas fa-shield-alt"></i>
                </div>
                <div class="notice-content">
                  <h6>Proteção de Dados</h6>
                  <p>
                    O IBCGP (Instituto Brasileiro de Ciência em Gestão Pública) atende à Lei nº 13.709/18 – Lei Geral de Proteção de Dados
                    Pessoais (LGPD), que dispõe sobre o tratamento de dados pessoais com o objetivo de proteger os direitos fundamentais de
                    liberdade e de privacidade e o livre desenvolvimento da personalidade da pessoa natural.
                  </p>
                </div>
              </div>

              <!-- Seções do Formulário -->
              <div class="form-sections">
                <div 
                  v-for="(form, ind) in formsVisiveis" 
                  :key="`${ind}-form`"
                  :class="['form-section', form.class]"
                  :data-step="getStepNumber(form.titulo)"
                >
                  <div class="section-header">
                    <div class="section-icon">
                      <i :class="[form.icon]"></i>
                    </div>
                    <div class="section-info">
                      <h5 class="section-title">{{ form.titulo }}</h5>
                      <p class="section-description">{{ getSectionDescription(form.titulo) }}</p>
                    </div>
                  </div>

                  <div class="section-content">
                  <div class="row">
                      <div 
                        v-for="(input, indInput) in form.inputs" 
                        :key="`${indInput}-input`"
                        :class="[input.class]"
                      >
                        <div 
                          :class="input.conditional ? (input.conditional(formulario) ? 'field-enter mb-3' : 'field-exit') : 'mb-3'"
                        >
                        <div v-if="input.key === 'cep' && buscandoCEP" class="cep-loading">
                          <i class="fas fa-spinner fa-spin"></i>
                          <span>Buscando endereço...</span>
                        </div>
                        <component
                            v-if="input.conditional ? input.conditional(formulario) : true"
                          :required="input.required"
                          :options="getOptions(input, formulario)"
                          :placeholder="input.placeholder"
                          :is-disabled="input.isDisabled || isDisabled || (input.key === 'cep' && buscandoCEP)"
                          :upper-case="input.upperCase"
                          :onPaste="input.onPaste"
                          :accept="input.accept"
                          :taggable="input.taggable"
                          :is="input.component"
                          :type="input.type"
                          :mask="input.mask"
                          :id="input.key"
                          :label="input.label"
                          v-model="formulario[input.key]"
                          @blur="handleBlur(input.key)"
                          @input="handleInput(input.key)"
                            :class="{ 'field-error': hasFieldError(input.key), 'field-loading': input.key === 'cep' && buscandoCEP }"
                        />
                          <div v-if="hasFieldError(input.key)" class="field-error-message">
                            {{ getFieldError(input.key) }}
                          </div>
                          <div v-if="input.key === 'cep' && !buscandoCEP && formulario.endereco && !hasFieldError('cep')" class="cep-success">
                            <i class="fas fa-check-circle"></i>
                            <span>Endereço encontrado!</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Botões de Ação -->
              <div class="form-actions">
                <div v-if="!isDisabled" class="actions-container">
                  <div class="form-validation">
                    <div class="validation-item" :class="{ valid: formulario.nomeValido && formulario.nome }">
                      <i class="fas fa-check-circle" v-if="formulario.nomeValido && formulario.nome"></i>
                      <i class="fas fa-times-circle" v-else></i>
                      <span>Nome completo válido</span>
                    </div>
                    <div class="validation-item" :class="{ valid: formulario.cpfValido && formulario.cpf }">
                      <i class="fas fa-check-circle" v-if="formulario.cpfValido && formulario.cpf"></i>
                      <i class="fas fa-times-circle" v-else></i>
                      <span>CPF válido e disponível</span>
                    </div>
                    <div class="validation-item" :class="{ valid: formulario.idadeValida && formulario.data_nascimento }">
                      <i class="fas fa-check-circle" v-if="formulario.idadeValida && formulario.data_nascimento"></i>
                      <i class="fas fa-times-circle" v-else></i>
                      <span>Idade mínima de 18 anos</span>
                    </div>
                    <div class="validation-item" :class="{ valid: formulario.email === formulario.repeatEmail && formulario.email }">
                      <i class="fas fa-check-circle" v-if="formulario.email === formulario.repeatEmail && formulario.email"></i>
                      <i class="fas fa-times-circle" v-else></i>
                      <span>E-mails coincidem</span>
                    </div>
                    <div class="validation-item" :class="{ valid: formulario.emailValido && formulario.email }">
                      <i class="fas fa-check-circle" v-if="formulario.emailValido && formulario.email"></i>
                      <i class="fas fa-times-circle" v-else></i>
                      <span>E-mail disponível</span>
                    </div>
                    <div class="validation-item" :class="{ valid: formulario.senha === formulario.repeatSenha && formulario.senha.length >= 6 }">
                      <i class="fas fa-check-circle" v-if="formulario.senha === formulario.repeatSenha && formulario.senha.length >= 6"></i>
                      <i class="fas fa-times-circle" v-else></i>
                      <span>Senhas coincidem (mín. 6 caracteres)</span>
                    </div>
                  </div>
                  
                  <!-- Consentimento LGPD -->
                  <div class="lgpd-consent mb-4">
                    <div class="lgpd-consent-box">
                      <label class="lgpd-checkbox-label">
                        <input 
                          type="checkbox" 
                          v-model="aceitaLGPD" 
                          class="lgpd-checkbox-input"
                          required
                        />
                        <span class="lgpd-checkbox-text">
                          <i class="fas fa-check-circle" v-if="aceitaLGPD"></i>
                          <i class="far fa-circle" v-else></i>
                          <span class="lgpd-text-content">
                            <strong>Consentimento para Tratamento de Dados Pessoais (LGPD)</strong><br>
                            <small>
                              Autorizo o IBCGP (Instituto Brasileiro de Ciência em Gestão Pública) a coletar, armazenar, 
                              processar e utilizar meus dados pessoais fornecidos neste cadastro, exclusivamente para as 
                              finalidades relacionadas aos processos seletivos e concursos públicos, conforme previsto na 
                              Lei nº 13.709/18 (LGPD). Declaro estar ciente de que posso exercer meus direitos de acesso, 
                              correção, exclusão e portabilidade dos dados, bem como revogar este consentimento a qualquer 
                              momento, mediante solicitação ao e-mail: <a href="mailto:suporte@ibcgp.org.br" class="lgpd-link">suporte@ibcgp.org.br</a>.
                            </small>
                          </span>
                        </span>
                      </label>
                      <div v-if="!aceitaLGPD && isSubmitting" class="lgpd-error-message">
                        <i class="fas fa-exclamation-circle"></i>
                        É necessário aceitar o consentimento para tratamento de dados pessoais para continuar.
                      </div>
                    </div>
                  </div>
                  
                <button
                  type="submit"
                    :disabled="!isConfirmed || isSubmitting"
                    class="btn btn-primary btn-submit"
                >
                    <i v-if="isSubmitting" class="fas fa-spinner fa-spin me-2"></i>
                    <i v-else class="fas fa-user-plus me-2"></i>
                    {{ isSubmitting ? 'Cadastrando...' : 'Finalizar Cadastro' }}
                </button>
              </div>

                <div v-else-if="formulario.cpf" class="success-container">
                  <div class="success-message">
                    <i class="fas fa-check-circle"></i>
                    <h5>Cadastro Realizado com Sucesso!</h5>
                    <p>Seus dados foram salvos. Verifique seu e-mail para confirmação.</p>
                  </div>
                  <button @click="logOut" class="btn btn-outline-primary">
                    <i class="fas fa-home me-1"></i>Voltar ao Início
                  </button>
                </div>
              </div>

              <!-- Informações de Suporte -->
              <div class="support-info">
                <div class="support-content">
                  <i class="fas fa-question-circle"></i>
                  <div class="support-text">
                    <h6>Precisa de Ajuda?</h6>
                    <p>
                      Se tiver alguma dúvida ou problema com seu cadastro, entre em contato:
                      <a :href="`mailto:${suporte}`" class="support-email">{{ suporte }}</a>
                    </p>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import axios from 'axios'
import Footer from '@/components/Footer'
import { sections as forms } from './formInputs'
import Informacoes from '@/components/Informacoes'

export default {
  name: 'CadastroComp',

  components: {
    Footer,
    Informacoes
  },

  data() {
    return {
      suporte: 'suporte@ibcgp.org.br',
      isDisabled: false,
      isSubmitting: false,
      currentStep: 1,
      fieldErrors: {},
      buscandoCEP: false,
      aceitaLGPD: false,
      forms,
      formulario: {
        nome: '',
        cpf: '',
        rg: '',
        rg_orgao_emissor: '',
        rg_data_emissao: '',
        sexo: '',
        data_nascimento: '',
        estado_civil: '',
        nacionalidade: '',
        natural_uf: '',
        natural_cidade: '',
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        uf: '',
        cidade: '',
        bairro: '',
        telefone_celular: '',
        telefone_residencial: '',
        telefone_comercial: '',
        email: '',
        repeatEmail: '',
        senha: '',
        repeatSenha: '',
        nome_mae: '',
        nome_pai: '',
        possui_deficiencia: 'N',
        detalhe_deficiencia: '',
        possui_condicao_especial: 'N',
        detalhe_condicao_especial: '',
        id: '',
        createdAt: '',
        cpfValido: false,
        emailValido: false,
        idadeValida: false,
        nomeValido: false
      }
    }
  },

  methods: {
    voltarHome() {
      this.$router.push({ name: 'home' })
    },

    logOut() {
      this.$router.push({ name: 'home' })
    },

    getStepNumber(titulo) {
      const stepMap = {
        'Dados Pessoais': 1,
        'Endereço': 2,
        'Contato': 3,
        'Acesso': 4
      }
      return stepMap[titulo] || 1
    },

    getSectionDescription(titulo) {
      const descriptions = {
        'Dados Pessoais': 'Informações básicas para identificação',
        'Endereço': 'Localização e residência',
        'Contato': 'Telefones e e-mail para comunicação',
        'Acesso': 'Credenciais para login no sistema'
      }
      return descriptions[titulo] || ''
    },

    updateProgress() {
      // Atualizar progresso baseado nos campos preenchidos
      let step = 1
      
      if (this.formulario.nome && this.formulario.nomeValido && this.formulario.cpf && this.formulario.cpfValido && this.formulario.data_nascimento) {
        step = 2
      }
      if (step >= 2 && this.formulario.endereco && this.formulario.cidade && this.formulario.uf) {
        step = 3
      }
      if (step >= 3 && this.formulario.telefone_celular && this.formulario.email && this.formulario.emailValido) {
        step = 4
      }
      
      this.currentStep = step
    },

    hasFieldError(field) {
      return this.fieldErrors[field] !== undefined
    },

    getFieldError(field) {
      return this.fieldErrors[field]
    },

    setFieldError(field, message) {
      this.$set(this.fieldErrors, field, message)
    },

    clearFieldError(field) {
      this.$delete(this.fieldErrors, field)
    },

    getOptions(input, formulario) {
      if (typeof input.options === 'function') return input?.options(formulario, input.key) || []
      return input.options
    },

    handleInput(field) {
      // Atualizar progresso
      this.updateProgress();
      
      // Limpar erro quando começar a digitar novamente
      if (field === "nome" && this.hasFieldError('nome')) {
        // Não limpar erro imediatamente, apenas quando o nome for válido
        if (this.formulario.nome && this.formulario.nome.trim().split(' ').length >= 2) {
          this.clearFieldError('nome');
        }
      }
    },

    handleBlur(field) {
        if (field === "nome" && this.formulario.nome) {
          this.validarNome();
        } else if (field === "cpf" && this.formulario.cpf) {
          this.verificarCPF();
        } else if (field === "data_nascimento") {
          this.validarIdade();
        } else if (field === "repeatEmail") {
          this.verificarEmail();
        } else if (field === "repeatSenha") {
          this.validarSenhas();
        } else if (field === "cep" && this.formulario.cep) {
          this.buscarCEP();
        }
    },

    validarNome() {
      if (!this.formulario.nome) {
        this.formulario.nomeValido = false;
        this.setFieldError('nome', 'Nome completo é obrigatório');
        return false;
      }

      // Remove espaços extras e divide por espaços
      const nomeLimpo = this.formulario.nome.trim().replace(/\s+/g, ' ');
      const palavras = nomeLimpo.split(' ');

      // Verifica se tem pelo menos 2 palavras (nome e sobrenome)
      if (palavras.length < 2) {
        this.formulario.nomeValido = false;
        this.setFieldError('nome', 'Por favor, digite o nome completo (nome e sobrenome)');
        this.$sweet.sweetMensagem('Por favor, digite o nome completo (nome e sobrenome)');
        return false;
      }

      // Verifica se cada palavra tem pelo menos 2 caracteres
      for (let palavra of palavras) {
        if (palavra.length < 2) {
          this.formulario.nomeValido = false;
          this.setFieldError('nome', 'Cada parte do nome deve ter pelo menos 2 caracteres');
          this.$sweet.sweetMensagem('Cada parte do nome deve ter pelo menos 2 caracteres');
          return false;
        }
      }

      // Verifica se o nome completo tem pelo menos 6 caracteres (ex: "João Silva")
      if (nomeLimpo.length < 6) {
        this.formulario.nomeValido = false;
        this.setFieldError('nome', 'O nome completo deve ter pelo menos 6 caracteres');
        this.$sweet.sweetMensagem('O nome completo deve ter pelo menos 6 caracteres');
        return false;
      }

      this.formulario.nomeValido = true;
      this.clearFieldError('nome');
      return true;
    },

    validarCPF(cpf) {
      // Remove caracteres não numéricos
      cpf = cpf.replace(/\D/g, '');

      // Verifica se tem 11 dígitos
      if (cpf.length !== 11) {
        return false;
      }

      // Verifica se todos os dígitos são iguais (ex: 111.111.111-11)
      if (/^(\d)\1{10}$/.test(cpf)) {
        return false;
      }

      // Validação dos dígitos verificadores
      let soma = 0;
      let resto;

      // Valida primeiro dígito verificador
      for (let i = 1; i <= 9; i++) {
        soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
      }
      resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== parseInt(cpf.substring(9, 10))) {
        return false;
      }

      // Valida segundo dígito verificador
      soma = 0;
      for (let i = 1; i <= 10; i++) {
        soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
      }
      resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== parseInt(cpf.substring(10, 11))) {
        return false;
      }

      return true;
    },

    async salvar() {
      if (!this.isConfirmed) {
        if (!this.aceitaLGPD) {
          return this.$sweet.sweetMensagem(`É necessário aceitar o consentimento para tratamento de dados pessoais (LGPD) para continuar.`)
        }
        return this.$sweet.sweetMensagem(`Por favor, verifique se os dados estão corretos.`)
      }

      this.isSubmitting = true
      this.$sweet.sweetWait('Aguarde enquanto salvamos suas informações...')

      try {
      const params = { ...this.formulario, cpf: this.formulario.cpf.replace(/\D/g, '') }
      delete params.id
      
      // Garantir que campos de deficiência e condição especial sejam enviados como 'N' (false)
      // A API pode esperar 'S' ou 'N', então enviamos 'N' como padrão
      params.possui_deficiencia = params.possui_deficiencia || 'N'
      params.possui_condicao_especial = params.possui_condicao_especial || 'N'
      params.detalhe_deficiencia = params.detalhe_deficiencia || ''
      params.detalhe_condicao_especial = params.detalhe_condicao_especial || ''

        const { status } = await axios.post(`ps/candidato/registrar`, null, { params })

      if (status >= 200 && status < 300) {
        this.isDisabled = true
          this.isSubmitting = false
        this.$sweet.sweetSuccess(
            `<h5 class="mb-3">🎉 Cadastro realizado com sucesso!</h5>
          <div class="bg-light py-3 px-4 mt-3">
              <h6 class="text-success mb-3">📧 Atenção!</h6>
            <p class="text-modal text-center">Você já pode acessar o sistema com seu e-mail e senha.</p>
          </div>`,
          15000
        )
        return
      }
      } catch (error) {
        console.error('Erro ao salvar:', error)
        this.isSubmitting = false
        
        if (error.response && error.response.status === 400) {
          this.$sweet.sweetMensagem('Dados inválidos. Verifique as informações e tente novamente.')
        } else if (error.response && error.response.status === 409) {
          this.$sweet.sweetMensagem('Já existe um cadastro com estes dados.')
        } else {
          this.$sweet.sweetMensagem('Erro ao salvar os dados. Tente novamente.')
        }
      }
    },

    async verificarCPF() {
      const cpf = this.formulario.cpf.replace(/\D/g, ''); // Remove pontos e traços do CPF
      
      // Primeiro, valida a estrutura e dígitos verificadores do CPF
      if (!this.validarCPF(this.formulario.cpf)) {
        this.formulario.cpfValido = false;
        this.setFieldError('cpf', 'CPF inválido. Por favor, verifique os dígitos.');
        this.$sweet.sweetMensagem('CPF inválido. Por favor, verifique os dígitos.');
        return;
      }

      // Se o CPF é válido, verifica se já existe no sistema
      if (cpf.length === 11) {
        try {
          const response = await axios.get(`/ps/candidato/cpf/${cpf}`);

          if (response.status === 200) {
            this.$sweet.sweetMensagem("Já existe um cadastro com este CPF!");
            this.formulario.cpfValido = false;
            this.setFieldError('cpf', 'Este CPF já está cadastrado no sistema');
          } else if (response.status === 404) {
            this.formulario.cpfValido = true;
            this.clearFieldError('cpf');
          }
        } catch (error) {
          // Se retornar 404, o CPF está disponível
          if (error.response && error.response.status === 404) {
            this.formulario.cpfValido = true;
            this.clearFieldError('cpf');
          } else {
            console.warn("Erro ao buscar CPF:", error);
            this.formulario.cpfValido = false;
            this.setFieldError('cpf', 'Erro ao verificar CPF. Tente novamente.');
          }
        }
      } else {
        // Se o CPF não tem 11 dígitos, não está válido
        this.formulario.cpfValido = false;
        this.setFieldError('cpf', 'CPF deve conter 11 dígitos');
      }
    },

  async verificarEmail() {
    if (this.formulario.email !== this.formulario.repeatEmail) {
      this.$sweet.sweetMensagem("Os e-mails digitados não coincidem!");
      this.formulario.emailValido = false;
      return;
    }

    // Validar formato básico de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(this.formulario.email)) {
      this.formulario.emailValido = false;
      return;
    }

    try {
      const response = await axios.get(`/ps/candidato/email/${this.formulario.email}`);

      if (response.status === 200) {
        this.$sweet.sweetMensagem("Já existe um cadastro com este e-mail!");
        this.formulario.emailValido = false;
      } else if (response.status === 404) {
        this.formulario.emailValido = true;
      }
    } catch (error) {
      // Se retornar 404, o email está disponível
      if (error.response && error.response.status === 404) {
        this.formulario.emailValido = true;
      } else {
        console.warn("Erro ao verificar e-mail:", error);
        this.formulario.emailValido = false;
      }
    }
  },

  validarSenhas() {
      if (this.formulario.senha !== this.formulario.repeatSenha) {
        this.$sweet.sweetMensagem("As senhas digitadas não coincidem!");
        return false;
      }

      if (this.formulario.senha.length < 6) {
        this.$sweet.sweetMensagem("A senha deve ter pelo menos 6 caracteres!");
        return false;
      }

      return true;
    },

    validarIdade() {
      if (!this.formulario.data_nascimento) {
        this.formulario.idadeValida = false
        return false
      }

      // A data vem no formato brasileiro DD/MM/YYYY
      // Precisamos converter para um formato que o JavaScript entenda
      const dataStr = this.formulario.data_nascimento.trim()
      
      // Verificar se está no formato DD/MM/YYYY
      const regexData = /^(\d{2})\/(\d{2})\/(\d{4})$/
      const match = dataStr.match(regexData)
      
      if (!match) {
        this.formulario.idadeValida = false
        return false
      }
      
      const dia = parseInt(match[1], 10)
      const mes = parseInt(match[2], 10) - 1 // JavaScript usa meses de 0-11
      const ano = parseInt(match[3], 10)
      
      // Criar objeto Date com os valores corretos
      const nascimento = new Date(ano, mes, dia)
      const hoje = new Date()
      
      // Verificar se a data é válida
      if (isNaN(nascimento.getTime())) {
        this.formulario.idadeValida = false
        return false
      }
      
      // Calcular idade considerando mês e dia
      let idade = hoje.getFullYear() - nascimento.getFullYear()
      const mesAtual = hoje.getMonth()
      const diaAtual = hoje.getDate()
      const mesNascimento = nascimento.getMonth()
      const diaNascimento = nascimento.getDate()
      
      // Se ainda não fez aniversário este ano, subtrai 1
      if (mesAtual < mesNascimento || (mesAtual === mesNascimento && diaAtual < diaNascimento)) {
        idade--
      }
      
      // Verificar se tem pelo menos 18 anos
      if (idade >= 18) {
        this.formulario.idadeValida = true
        return true
      } else {
        this.formulario.idadeValida = false
        this.$sweet.sweetMensagem("É necessário ter pelo menos 18 anos para se cadastrar!")
        return false
      }
    },

    async buscarCEP() {
      // Remove caracteres não numéricos do CEP
      const cep = this.formulario.cep.replace(/\D/g, '')
      
      // Valida se o CEP tem 8 dígitos
      if (cep.length !== 8) {
        if (cep.length > 0) {
          this.setFieldError('cep', 'CEP deve conter 8 dígitos')
        }
        return
      }

      this.buscandoCEP = true
      this.clearFieldError('cep')

      try {
        // Usar fetch ao invés de axios para evitar headers customizados que causam CORS
        // A API ViaCEP não aceita headers customizados como 'Access'
        const controller = new AbortController()
        const timeoutId = setTimeout(() => controller.abort(), 5000) // Timeout de 5 segundos
        
        const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`, {
          method: 'GET',
          signal: controller.signal,
          headers: {
            'Accept': 'application/json'
          }
        })
        
        clearTimeout(timeoutId)
        
        if (!response.ok) {
          throw new Error('Erro na requisição')
        }
        
        const data = await response.json()
        
        if (data.erro) {
          this.$sweet.sweetMensagem('CEP não encontrado. Por favor, preencha o endereço manualmente.')
          this.setFieldError('cep', 'CEP não encontrado')
          return
        }

        // Preenche os campos automaticamente
        this.formulario.endereco = data.logradouro || ''
        this.formulario.bairro = data.bairro || ''
        this.formulario.cidade = data.localidade || ''
        this.formulario.uf = data.uf || ''
        
        // Atualiza o progresso após preencher os campos
        this.updateProgress()
        
      } catch (error) {
        console.error('Erro ao buscar CEP:', error)
        
        if (error.name === 'AbortError') {
          this.$sweet.sweetMensagem('Tempo de busca excedido. Verifique sua conexão e tente novamente.')
        } else {
          this.$sweet.sweetMensagem('Erro ao buscar CEP. Por favor, preencha o endereço manualmente.')
        }
        
        this.setFieldError('cep', 'Erro ao buscar CEP')
      } finally {
        this.buscandoCEP = false
      }
    }
  },

  computed: {
    formsVisiveis() {
      return this.forms.filter(form => !form.hidden)
    },
    
    isConfirmed() {
      return (
        this.formulario.nome &&
        this.formulario.nomeValido && // Nome deve ser completo
        this.formulario.cpf &&
        this.formulario.cpfValido && // CPF deve ser válido e disponível
        this.formulario.email &&
        this.formulario.email === this.formulario.repeatEmail &&
        this.formulario.emailValido && // Email deve estar disponível
        this.formulario.senha &&
        this.formulario.senha === this.formulario.repeatSenha &&
        this.formulario.senha.length >= 6 &&
        this.formulario.telefone_celular &&
        this.formulario.idadeValida && // Idade deve ser >= 18 anos
        this.aceitaLGPD // Consentimento LGPD obrigatório
      )
    }
  },

  mounted() {
    // Atualizar progresso inicial
    this.updateProgress()
  }
}
</script>

<style lang="sass">
/* Página do Formulário */
.form-page
  min-height: 100vh
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%)

/* Navbar do Formulário */
.form-navbar
  background: rgba(255, 255, 255, 0.95)
  backdrop-filter: blur(10px)
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1)
  padding: 15px 0

.navbar-brand img
  height: 40px

/* Indicador de Progresso */
.progress-section
  background: rgba(255, 255, 255, 0.1)
  padding: 20px 0
  margin-bottom: 30px

.progress-container
  display: flex
  align-items: center
  justify-content: center
  max-width: 600px
  margin: 0 auto

.progress-step
  display: flex
  flex-direction: column
  align-items: center
  position: relative

.step-number
  width: 40px
  height: 40px
  border-radius: 50%
  background: rgba(255, 255, 255, 0.3)
  color: white
  display: flex
  align-items: center
  justify-content: center
  font-weight: 600
  font-size: 14px
  transition: all 0.3s ease

.step-label
  color: white
  font-size: 12px
  font-weight: 500
  margin-top: 8px
  text-align: center

.progress-step.active .step-number
  background: white
  color: #667eea
  transform: scale(1.1)

.progress-step.completed .step-number
  background: #28a745
  color: white

.progress-line
  width: 60px
  height: 2px
  background: rgba(255, 255, 255, 0.3)
  margin: 0 10px
  transition: all 0.3s ease

.progress-line.active
  background: white

/* Conteúdo Principal */
.form-main
  padding: 0 0 50px 0

.modern-form
  background: white
  border-radius: 20px
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1)
  overflow: hidden

/* Header do Formulário */
.form-header
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  color: white
  padding: 40px 30px
  text-align: center

.form-logo img
  width: 80px
  height: auto
  margin-bottom: 20px

.form-title
  font-size: 2rem
  font-weight: 700
  margin-bottom: 10px

.form-subtitle
  font-size: 1.1rem
  opacity: 0.9
  margin-bottom: 0

/* Aviso LGPD */
.lgpd-notice
  background: #f8f9fa
  border-left: 4px solid #667eea
  padding: 20px
  margin: 30px
  border-radius: 8px
  display: flex
  align-items: flex-start
  gap: 15px

.notice-icon
  color: #667eea
  font-size: 1.5rem
  margin-top: 2px

.notice-content h6
  color: #2c3e50
  font-weight: 600
  margin-bottom: 8px

.notice-content p
  color: #6c757d
  font-size: 0.9rem
  line-height: 1.5
  margin-bottom: 0

/* Seções do Formulário */
.form-sections
  padding: 30px

.form-section
  margin-bottom: 40px
  border: 1px solid #e9ecef
  border-radius: 12px
  overflow: hidden
  transition: all 0.3s ease

.form-section:hover
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1)

.section-header
  background: #f8f9fa
  padding: 20px
  display: flex
  align-items: center
  gap: 15px
  border-bottom: 1px solid #e9ecef

.section-icon
  width: 50px
  height: 50px
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  border-radius: 12px
  display: flex
  align-items: center
  justify-content: center
  color: white
  font-size: 1.2rem

.section-info
  flex: 1

.section-title
  color: #2c3e50
  font-weight: 600
  margin-bottom: 5px
  font-size: 1.2rem

.section-description
  color: #6c757d
  font-size: 0.9rem
  margin-bottom: 0

.section-content
  padding: 25px

/* Campos do Formulário */
.form-control
  border: 2px solid #e9ecef
  border-radius: 8px
  padding: 12px 15px
  font-size: 0.95rem
  transition: all 0.3s ease

.form-control:focus
  border-color: #667eea
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25)

.form-control.field-error
  border-color: #dc3545

.field-error-message
  color: #dc3545
  font-size: 0.8rem
  margin-top: 5px

label
  font-weight: 600
  color: #495057
  margin-bottom: 8px
  font-size: 0.9rem

/* Animações de Campos */
.field-enter
  max-height: 200px
  opacity: 1
  transition: all 0.5s ease-out

.field-exit
  max-height: 0
  opacity: 0
  overflow: hidden
  transition: all 0.5s ease-out

/* Ações do Formulário */
.form-actions
  padding: 30px
  background: #f8f9fa
  border-top: 1px solid #e9ecef

.actions-container
  text-align: center

.form-validation
  display: flex
  flex-direction: column
  gap: 10px
  margin-bottom: 25px
  padding: 20px
  background: white
  border-radius: 12px
  border: 1px solid #e9ecef

.validation-item
  display: flex
  align-items: center
  gap: 10px
  font-size: 0.9rem
  color: #6c757d

.validation-item.valid
  color: #28a745

.validation-item i
  font-size: 1rem

.btn-submit
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  border: none
  padding: 15px 40px
  font-size: 1.1rem
  font-weight: 600
  border-radius: 12px
  transition: all 0.3s ease

.btn-submit:hover:not(:disabled)
  transform: translateY(-2px)
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4)

.btn-submit:disabled
  background: #6c757d
  cursor: not-allowed
  transform: none

/* Estado de Sucesso */
.success-container
  text-align: center

.success-message
  background: #d4edda
  border: 1px solid #c3e6cb
  color: #155724
  padding: 25px
  border-radius: 12px
  margin-bottom: 20px

.success-message i
  font-size: 2rem
  margin-bottom: 15px
  color: #28a745

.success-message h5
  color: #155724
  margin-bottom: 10px

/* Informações de Suporte */
.support-info
  padding: 20px 30px
  background: #f8f9fa
  border-top: 1px solid #e9ecef

.support-content
  display: flex
  align-items: flex-start
  gap: 15px

.support-content i
  color: #667eea
  font-size: 1.5rem
  margin-top: 2px

.support-text h6
  color: #2c3e50
  font-weight: 600
  margin-bottom: 8px

.support-text p
  color: #6c757d
  font-size: 0.9rem
  line-height: 1.5
  margin-bottom: 0

.support-email
  color: #667eea
  text-decoration: none
  font-weight: 600

.support-email:hover
  text-decoration: underline

/* Responsividade */
@media (max-width: 768px)
  .form-header
    padding: 30px 20px

  .form-title
    font-size: 1.5rem

  .form-subtitle
    font-size: 1rem

  .progress-container
    flex-wrap: wrap
    gap: 10px

  .progress-line
    width: 30px

  .form-sections
    padding: 20px

  .section-header
    padding: 15px
    flex-direction: column
    text-align: center

  .section-content
    padding: 20px

  .form-validation
    flex-direction: column
    gap: 8px

  .lgpd-notice
    margin: 20px
    flex-direction: column
    text-align: center

  .support-content
    flex-direction: column
    text-align: center

@media (max-width: 576px)
  .form-page
    padding: 0

  .modern-form
    border-radius: 0
    margin: 0

  .form-header
    padding: 25px 15px

  .form-sections
    padding: 15px

  .section-content
    padding: 15px

  .form-actions
    padding: 20px 15px

  .btn-submit
    width: 100%
    padding: 15px

/* Animações */
@keyframes fadeInUp
  from
    opacity: 0
    transform: translateY(30px)
  to
    opacity: 1
    transform: translateY(0)

.form-section
  animation: fadeInUp 0.6s ease-out

/* Melhorias nos componentes existentes */
.text-area
  min-height: 100px
  resize: vertical

.check-confirm
  width: 20px
  height: 20px

.height-30
  height: 30px

.w-55
  width: 55%

.w-45
  width: 45%

.px-3-important
  padding-left: 0.8rem !important
  padding-right: 0.8rem !important

.bg-light
  background-color: #f8f9fa !important

.incomplet
  background-color: #ff6f6f1a
  border-radius: 8px
  border: 1px solid #ff6f6f

  .label
    color: #a80a0a !important

  .form-control, .vs__dropdown-toggle, .form-check-input
    border-color: #a80a0a !important

/* Indicadores de CEP */
.cep-loading
  display: flex
  align-items: center
  gap: 8px
  color: #667eea
  font-size: 0.85rem
  margin-top: 5px
  margin-bottom: 5px
  
  i
    font-size: 0.9rem

.cep-success
  display: flex
  align-items: center
  gap: 8px
  color: #28a745
  font-size: 0.85rem
  margin-top: 5px
  
  i
    font-size: 0.9rem

.field-loading
  border-color: #667eea !important
  background-color: #f8f9ff

/* Consentimento LGPD */
.lgpd-consent
  margin-top: 20px
  margin-bottom: 20px

.lgpd-consent-box
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)
  border: 2px solid #dee2e6
  border-radius: 12px
  padding: 20px
  transition: all 0.3s ease

  &:hover
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1)
    border-color: #667eea

.lgpd-checkbox-label
  display: flex
  align-items: flex-start
  cursor: pointer
  user-select: none
  transition: all 0.3s ease

  &:hover
    .lgpd-checkbox-text
      color: #667eea

.lgpd-checkbox-input
  display: none

.lgpd-checkbox-text
  display: flex
  align-items: flex-start
  gap: 12px
  font-size: 14px
  color: #495057
  line-height: 1.6
  transition: color 0.3s ease

  i
    font-size: 20px
    color: #6c757d
    margin-top: 2px
    transition: color 0.3s ease
    flex-shrink: 0

  .fa-check-circle
    color: #28a745

  .fa-circle
    color: #6c757d

.lgpd-text-content
  flex: 1

  strong
    color: #2c3e50
    font-weight: 600
    display: block
    margin-bottom: 8px

  small
    color: #6c757d
    font-size: 13px
    line-height: 1.6
    display: block

.lgpd-link
  color: #667eea
  text-decoration: none
  font-weight: 600
  transition: color 0.3s ease

  &:hover
    color: #764ba2
    text-decoration: underline

.lgpd-error-message
  display: flex
  align-items: center
  gap: 8px
  color: #dc3545
  font-size: 13px
  margin-top: 10px
  padding: 10px
  background: #f8d7da
  border: 1px solid #f5c6cb
  border-radius: 6px

  i
    font-size: 16px

// Quando o checkbox está marcado
.lgpd-checkbox-input:checked + .lgpd-checkbox-text
  color: #28a745

  i
    color: #28a745

  .lgpd-text-content strong
    color: #155724

// Responsividade
@media (max-width: 768px)
  .lgpd-consent-box
    padding: 15px

  .lgpd-checkbox-text
    font-size: 13px

    .lgpd-text-content small
      font-size: 12px
</style>
